import styled from 'styled-components'
import { StyledGlobalMainContainer } from '../globalStyle'

export const StyledMainContainer = styled(StyledGlobalMainContainer)`
  z-index: 1010;
  @media (max-width: 1200px) {
    padding-right: 22px;
  }
`

export const StyledInnerDiv = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  margin-top: 114px;
`

export const StyledHeaderContainer = styled.div`
  /* 
background-repeat: no-repeat;
background-position: right top;
padding: 22px 155px; */
`

export const StyledHeaderTitle = styled.div`
  display: grid;
  grid-row-gap: 34px;
  position: relative;
  top: -50px;
  @media (max-width: 768px) {
    justify-items: start;
    top: 0px;
    p:nth-child(1) {
      max-width: 75%;
    }
  }
  @media (max-width: 425px) {
    justify-items: center;
    grid-row-gap: 24px;
    top: 0px;
    p:nth-child(1) {
      font-size: 16px;
      max-width: 85%;
      text-align: center;
      margin: 0 auto;
    }
  }
`

export const StyledButtonContainer = styled.div`
  display: inline-grid;
  grid-auto-flow: column;
  align-items: center;
  grid-column-gap: 45px;
  margin-top: 57px;
  position: relative;
  top: -20px;

  button {
    width: 180px;
    height: 56px;
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    margin-top: 66px;
    grid-column-gap: 20px;
  }
`

export const StyledImageContainer = styled.div`
  width: 1131px;
  border: 1px solid red;
`

export const StyledAboutContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 35px;
  margin-top: 80px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-row-gap: 35px;
    margin-top: 57px;
  }
  @media (max-width: 425px) {
    grid-template-columns: 1fr;
    grid-row-gap: 30px;
    margin-top: 52px;
  }
`

export const StyledInnerContainer = styled.div`
  margin-top: 70px;
  @media (max-width: 768px) {
    margin-top: 52px;
  }
  @media (max-width: 425px) {
    margin-top: 46px;
  }
`

export const StyledLeftContainer = styled.div`
  ${({ headerLogoName }) =>
    headerLogoName &&
    `
		padding-top: 35px;
	`}
`

export const StyledAnimatedWrapper = styled.div`
  position: absolute;
  top: 168px;
  left: -100px;

  div:nth-child(2) {
    transform: translateX(72px);
  }
`

export const StyledRightContainer = styled.div`
  position: absolute;
  right: 0;
  top: 114px;
  display: grid;
  justify-items: end;
  @media (max-width: 1300px) {
    position: unset;
  }
  @media (max-width: 1200px) {
    width: 100%;
  }
  ${({ headerLogoName }) =>
    headerLogoName &&
    `
		position: unset;
	`}
`

export const StyledDesktopImg = styled.div``
export const StyledMobileImg = styled.div``
export const StyledInnerRightContainer = styled.div`
  position: relative;
  right: 0;
  display: inline-flex;
  @media (max-width: 1200px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    display: grid;
    justify-items: center;
  }
`

export const StyledMessageContainer = styled.div`
  z-index: 2;
  position: absolute;
  bottom: 126px;
  right: 173px;
  width: 195px;
  height: 95px;
  box-sizing: border-box;
`

export const StyledInput = styled.input`
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: capitalize;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  color: #000;

  :hover {
    color: #89c35c;
  }
`

export const StyledKvalifikaHeader = styled(StyledInnerDiv)`
  display: grid;
  grid-template-columns: 3fr 2fr;
  margin-top: 211px;
  grid-column-gap: 20px;
  @media (max-width: 1640px) {
    grid-column-gap: 40px;
  }
  @media (max-width: 1540px) {
    grid-column-gap: 260px;
  }
  @media (max-width: 1440px) {
    grid-template-columns: 2fr 2fr;
  }
  @media (max-width: 1300px) {
    grid-template-columns: 2fr 2fr;
    margin-top: 130px;
  }
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    grid-row-gap: 65px;
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    margin-top: 100px;
  }
  ${({ headerLogoName }) =>
    headerLogoName &&
    `
		margin-top: 144px;
	`}
`

export const StyledImageListContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  grid-column-gap: 24px;
  margin-top: 76px;
  @media (max-width: 576px) {
    grid-auto-flow: row;
    grid-row-gap: 10px;
    display: none;
  }
`
export const StyledLogoContainer = styled.div`
  height: 24px;

  img {
    height: 24px;
  }
`

export const StyledMobileImgKvalifiKa = styled.div`
  position: absolute;
  top: 160px;
  left: -130px;

  @media (max-width: 576px) {
    position: unset;
  }
`
export const StyledDesktopImgKvalifiKa = styled.div`
  svg {
    width: 669px;
    height: 454px;
    box-shadow: 0px 8px 34px 10px rgba(191, 196, 202, 0.25);
  }

  ${({ headerLogoName }) =>
    headerLogoName &&
    `
		svg{
			width: 507px;
			height: 524px;
		}
	`};
  @media (max-width: 1200px) {
    width: 100%;
    svg {
      width: 100%;
      height: auto;
    }
  }
`

export const StyledResponsiveContainer = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`
